export { default } from './BackgroundHero';

